export default "__VITE_ASSET__D$GbPDjt__"